import type { Reference as EntityReference } from 'sr-types/lib/search/v1/graphql';
import type { EntityName, EntitySecurity } from '../../../auth/Security';
import type { Reference } from '../../../reference/reference';
import type { SidePanelSubject } from '../../types';

type CreateSidePanelSubjectInput<T> = {
    entityName: EntityName;
    record: T;
    id?: string | null;
    reference?: EntityReference | null;
    label?: string | null;
    security?: EntitySecurity | null;
};

/** Pure subject construction; absent IDs or security fail closed without inventing permissions. */
export function createSidePanelSubject<T>({
    entityName,
    record,
    id,
    reference,
    label,
    security
}: CreateSidePanelSubjectInput<T>): SidePanelSubject<T> | null {
    const entityId = reference?.id || id;
    if (!entityId || !security) return null;

    const resolvedLabel = label ?? reference?.label ?? undefined;
    const subjectReference: Reference = {
        id: entityId,
        label: resolvedLabel,
        eventId: reference?.eventId ?? undefined,
        uriPrefix: reference?.uriPrefix ?? undefined,
        type: reference?.type ?? undefined,
        deleted: reference?.deleted ?? undefined
    };
    const subject: SidePanelSubject<T> = {
        entityName,
        reference: subjectReference,
        label: resolvedLabel,
        security,
        record
    };
    return subject;
}
